import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/Reveal";
import { ARTICLES } from "@/data/articles";

export default function InsightsPage() {
  return (
    <>
      <Seo
        title="Insights — Improve Systems"
        siteName="Improve Systems"
        description="Field notes and methods on causal analysis, operational improvement, and continuous operational intelligence."
      />
      <PageHero
        eyebrow="INSIGHTS"
        title="Notes from the field."
        lede="Short, honest writing on how operational problems actually get diagnosed and solved — no hype, no vendor agenda."
        testid="insights-hero"
      />

      <section data-testid="insights-list" className="border-b border-line">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24">
          <div className="border-t border-line">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.07}>
                <Link
                  to={`/insights/${a.slug}`}
                  data-testid={`insight-card-${a.slug}`}
                  className="group grid gap-4 border-b border-line py-10 transition-colors duration-300 hover:bg-white sm:grid-cols-12 sm:items-baseline sm:gap-8"
                >
                  <span className="font-mono text-[11px] text-slate-400 sm:col-span-1">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="sm:col-span-8">
                    <h2 className="font-serif text-2xl leading-snug text-ink transition-colors duration-300 group-hover:text-accent-deep sm:text-3xl">
                      {a.title}
                    </h2>
                    <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600">
                      {a.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-6 sm:col-span-3 sm:justify-end">
                    <div className="text-right">
                      <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">
                        {a.tag}
                      </p>
                      <p className="mt-1 font-mono text-[10px] tracking-[0.25em] text-slate-400">
                        {a.date.toUpperCase()}
                      </p>
                    </div>
                    <ArrowUpRight className="h-4 w-4 text-slate-400 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
